import CV from "../assets/CV/CV.pdf";
import useLang from "../i18n/LanguageContext";
import { LANGS } from "../i18n/strings";
import "./Header.css";

const SunIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
  </svg>
);

const MoonIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z" />
  </svg>
);

const Header = ({ theme, onToggleTheme }) => {
  const { lang, setLang, t } = useLang();
  const dark = theme === "dark";

  return (
    <header className="header">
      <a href="#top" className="header__brand" data-critter="brand">
        mert kerimi
      </a>
      <nav aria-label={t.nav.primary} className="header__nav">
        <a href="#work" className="ln">{t.nav.work}</a>
        <a href="#skills" className="ln">{t.nav.skills}</a>
        <a href="#experience" className="ln">{t.nav.experience}</a>
        <a href="#about" className="ln">{t.nav.about}</a>
        <a href="#contact" className="ln">{t.nav.contact}</a>
        <a href={CV} download="Mert Kerimi CV.pdf" className="ln" data-critter="cv">{t.nav.cv}</a>
      </nav>
      <div className="header__end">
        <span className="header__status" data-critter="status">
          <span className="header__dot" />
          <span className="header__status-text">{t.status}</span>
        </span>
        <div className="header__lang" role="group" aria-label={t.lang.label} data-critter="lang">
          {LANGS.map((l) => (
            <button
              key={l}
              type="button"
              className={`header__cap${lang === l ? " is-active" : ""}`}
              aria-pressed={lang === l}
              lang={l}
              onClick={() => setLang(l)}
            >
              {l.toUpperCase()}
            </button>
          ))}
        </div>
        <button
          type="button"
          className="header__cap header__theme"
          data-critter="theme"
          onClick={onToggleTheme}
          aria-label={dark ? t.theme.toLight : t.theme.toDark}
        >
          {dark ? <SunIcon /> : <MoonIcon />}
          <span className="header__theme-label">{dark ? t.theme.light : t.theme.dark}</span>
        </button>
      </div>
    </header>
  );
};

export default Header;
